export const INQUIRY_SOURCES = [
  { value: 'walk_in', label: 'Walk-in' },
  { value: 'phone', label: 'Phone' },
  { value: 'website', label: 'Website' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'google', label: 'Google' },
  { value: 'referral', label: 'Referral' },
  { value: 'other', label: 'Other' },
];

export const INQUIRY_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'follow_up', label: 'Follow-up' },
  { value: 'interested', label: 'Interested' },
  { value: 'admission_confirmed', label: 'Admission Confirmed' },
  { value: 'not_interested', label: 'Not Interested' },
  { value: 'closed', label: 'Closed' },
];

export const COMPLAINT_PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

export const COMPLAINT_STATUSES = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export const APPOINTMENT_STATUSES = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'no_show', label: 'No Show' },
];

export const CALL_TYPES = [
  { value: 'incoming', label: 'Incoming' },
  { value: 'outgoing', label: 'Outgoing' },
];

export function labelFor(options, value) {
  return options.find((o) => o.value === value)?.label || value?.replace(/_/g, ' ') || '—';
}

export function staffLabel(u) {
  if (!u) return '—';
  const name = `${u.first_name || ''} ${u.last_name || ''}`.trim();
  return name || u.email || `#${u.id}`;
}

export function receptionApiErrorMessage(error, fallback = 'Request failed') {
  return error?.response?.data?.message
    || error?.message
    || (error?.response?.status ? `${fallback} (${error.response.status})` : fallback);
}
